function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "22.017"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_298",
  "data-name": "Rectangle 298",
  fill: "#4269a1",
  d: "M0 0h35v22.017H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_660",
  "data-name": "Group 660",
  clipPath: "url(#clip-path)",
  fill: "#4269a1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_411",
  "data-name": "Path 411",
  d: "M14.6 22.017h-2.59a2.177 2.177 0 01-2.091-1.59L5.009 2.75A2.169 2.169 0 017.1 0h12.406A2.169 2.169 0 0121.6 2.75l-4.912 17.677a2.179 2.179 0 01-2.091 1.59M7.1 1.842a.325.325 0 00-.315.414L11.7 19.935a.328.328 0 00.315.239H14.6a.329.329 0 00.315-.239l4.906-17.678a.318.318 0 00-.053-.286.324.324 0 00-.262-.129z",
  transform: "translate(4.15 .001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_412",
  "data-name": "Path 412",
  d: "M1.276 18.086a.921.921 0 010-1.842 6.364 6.364 0 100-12.729.921.921 0 010-1.842 8.207 8.207 0 010 16.413",
  transform: "translate(.299 1.409)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_413",
  "data-name": "Path 413",
  d: "M.921 13.186a.921.921 0 010-1.842 3 3 0 100-6 .921.921 0 010-1.842 4.844 4.844 0 110 9.688",
  transform: "translate(0 2.946)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_414",
  "data-name": "Path 414",
  d: "M21.9 18.086a8.207 8.207 0 110-16.413.921.921 0 010 1.842 6.364 6.364 0 100 12.729.921.921 0 010 1.842",
  transform: "translate(11.528 1.409)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_415",
  "data-name": "Path 415",
  d: "M20.714 13.186a4.844 4.844 0 010-9.688.921.921 0 010 1.842 3 3 0 000 6 .921.921 0 010 1.842",
  transform: "translate(13.365 2.946)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_416",
  "data-name": "Path 416",
  d: "M10.536 11.793a2.322 2.322 0 112.323-2.321 2.323 2.323 0 01-2.323 2.321m0-2.8a.48.48 0 00-.479.481c0 .529.96.529.96 0a.481.481 0 00-.481-.481",
  transform: "translate(6.918 6.021)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_417",
  "data-name": "Path 417",
  d: "M11.049 8.559a3.443 3.443 0 113.443-3.443 3.446 3.446 0 01-3.443 3.443m0-5.044a1.6 1.6 0 101.6 1.6 1.6 1.6 0 00-1.6-1.6",
  transform: "translate(6.405 1.409)"
}))));